import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Timer from './Timer'; 

const ConfirmationModal = (props = {}) => {

  const [ShowCancelButton, setShowCancelButton] = useState(false);
  const [ShowTimer, setShowTimer] = useState(false);
  const [timerDuration, settimerDuration] = useState(false);
    
    useEffect(() => {

      if( typeof props.ShowCancelButton !== 'undefined'){
        if( props.ShowCancelButton === true || props.ShowCancelButton === "true"){
          setShowCancelButton(true);
        }
      }
      if( typeof props.ShowTimer !== 'undefined'){
        if( props.ShowTimer === true || props.ShowTimer === "true"){
          setShowTimer(true);
          settimerDuration(props.timerDuration);
        }
      }
    }, [props]);

    const handleCancelClick = () => { props.onCancel(); };

    const handleOkClick = () => { props.onOk(); };

    const handleOnTimerExpire = () =>{ props.onOk(); };

    const handleCloseClick = () =>
    {
      try
      {
        props.onClose();
      }
      catch { 
        handleCancelClick();
      }
    };

  return (
    <Modal show={props.show} animation={false} onHide={handleCloseClick} backdrop={props.backdrop}>
      <Modal.Header closeButton onClick={handleCloseClick}>
        <Modal.Title>{props.Title}</Modal.Title>
        
      </Modal.Header>
      <Modal.Body>
        {/* Conditionally render the Timer if isActive is true */}
        {ShowTimer ?  
          <Timer
            duration={timerDuration}
            isActive={ShowTimer}
            onExpire={handleOnTimerExpire}
          /> : ""
        }
        {props.Body}
        </Modal.Body>
      <Modal.Footer>
        {ShowCancelButton?
        <Button variant="secondary" onClick={handleCancelClick}>
          {props.btnCanceText}
        </Button>
        : ""}
        <Button variant="primary" onClick={handleOkClick}>
          {props.btnOkText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;